import React, { useState } from 'react'
import HeaderLinks from '../../components/HeaderLinks'
import Menu from '../../components/Menu'
import { useAuthState } from '../../components/AuthProvider'
import typeDisplayOptions from '../../pages/Dashboard/typeDisplayOptions'
const SelectMenuList = ({
  dropdownData,
  defaultValue,
  defaultLabel,
  selectType,
  setDrillDownSelectedValueMethod,
}) => {
  const { user } = useAuthState()
  const [selectedValue, setSelectedValue] = useState(defaultValue)
  const [selectedLabel, setSelectedLabel] = useState(defaultLabel)

  const handleClick2 = (value, label) => {

    if (selectType === 'drilldown') setDrillDownSelectedValueMethod(value)
    setSelectedValue(value)
    setSelectedLabel(label)
    switch (value) {
      case 'home':   
        window.location.href = "/dashboard";
        break
      case 'rsv':
          window.location.href = "/rsvdashboard";
        break
      case 'flu':
            window.location.href = "/fludashboard";
        break
      case 'covid':
           window.location.href = "/coviddashboard";
        break
      case 'vulnerability':
           window.location.href = "/vulnerabilitydashboard";
        break
        case 'allergies':
              window.location.href = "/allergiesdashboard";
          break
        case 'birthtrend':
          window.location.href = "/birthtrenddashboard";
          break
        case 'flunew':
          window.location.href = "/flunew";         
          break        
        case 'uti':
          window.location.href = "/utidashboard";         
          break         
         case 'uti':
          window.location.href = "/utidashboard";         
          break         
        case 'meningitis':
          window.location.href = "/meningitisdashboard";         
          break 
         case 'raredisease':
          window.location.href = "/rarediseasedashboard";         
          break         
        case 'surviellance':
          window.location.href = "/surviellancedashboard";  
          break
        case 'vaccination':
          window.location.href = "/vaccinationdashboard";        
          break                   
        case 'shingles':
          window.location.href = "/shinglesdashboard";         
          break            
        
      default:
        break
    }
  }
  dropdownData =
    (process.env.REACT_APP_FEATURE_FLAG === undefined || process.env.REACT_APP_FEATURE_FLAG === 'true')?typeDisplayOptions[2]:
          (user.role === 'External' ? typeDisplayOptions[1] : typeDisplayOptions[0])
  return (
    <>
      <HeaderLinks>
        <>
          <HeaderLinks.Item
            label={selectedLabel}
            menuType="other"
            selectLabel={selectedLabel}
             tabIndex={0}
          >
            <Menu  >
              {dropdownData.map((option) => {
                return (
                  <Menu.Item
                    label={option.label}
                    key={option.value}
                    onClick={(event) =>
                      handleClick2(option.value, option.label)
                    }
                    
                    menuType="other"
                    selectLabel={selectedLabel}
                    tabIndex={0} // Make each menu item focusable
                  />
                )
              })}
            </Menu>
          </HeaderLinks.Item>
        </>
      </HeaderLinks>
    </>
  )
}
export default SelectMenuList